import { api } from '../core/client';

/** A Cashfree order the client uses to open hosted checkout. */
export interface ApiPaymentOrder {
  orderId: string;
  paymentSessionId: string;
  amount: number;
  /** SANDBOX | PRODUCTION — picks the Cashfree SDK mode. */
  mode: string;
  /** False when the gateway keys aren't set yet — show a clear message instead of redirecting. */
  configured: boolean;
}

/** Result of verifying a returned Cashfree order. */
export interface ApiPaymentVerify {
  paid: boolean;
  status: string;
  message: string;
}

interface ApiEnvelope<T> {
  success: boolean;
  message: string | null;
  result: T;
}

/**
 * Online payment (Cashfree) for an approved bill. Pay Now → createOrder → open Cashfree hosted
 * checkout with the paymentSessionId → on return, verify (which marks the bill paid + frees the
 * table when Cashfree confirms PAID).
 */
export const paymentService = {
  createOrder(billId: string): Promise<ApiPaymentOrder> {
    return api.post<ApiEnvelope<ApiPaymentOrder>>('/payment/cashfree/order', { billId }).then((r) => r.data.result);
  },

  verify(billId: string, orderId: string): Promise<ApiPaymentVerify> {
    return api.post<ApiEnvelope<ApiPaymentVerify>>('/payment/cashfree/verify', { billId, orderId }).then((r) => r.data.result);
  }
};
